module.exports = __webpack_public_path__ + "img/weddingRingsMorningGlow-emotion-02.5bd8d85.webp";